import React from 'react';
import { setCurrentView } from 'core/utils';
import { ChangeWarehouseShipByDateViewStore } from 'modules/order/stores';
import { ChangeWarehouseShipByDateTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new ChangeWarehouseShipByDateViewStore(rootStore, componentProps),
	'changeWarehouseShipByDateViewStore'
)
class ChangeWarehouseShipByDate extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ChangeWarehouseShipByDateTemplate {...this.props} />;
	}
}

export default ChangeWarehouseShipByDate;
